import { useParams } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getStudentSessions, getStudentAnalyticsTrades, getMyStudents } from "wasp/client/operations";
import StudentLayout from "./StudentLayout";
import { SessionsView } from "../trading-sessions/SessionsView";
import useTranslation from "../client/hooks/useTranslation";

export default function StudentSessionsPage() {
  const t = useTranslation();
  const { studentId } = useParams<{ studentId: string }>();

  const { data: students = [], isLoading: loadingStudents } = useQuery(getMyStudents);
  const student = studentId ? students.find((s: any) => s.studentId === studentId) : undefined;
  const permissions = student?.permissions ?? {
    canViewJournal: false,
    canViewDashboard: false,
    canViewAnalytics: false,
    canViewSessions: false,
    canViewPropFirmManager: false,
  };

  const enabled = !!studentId && !loadingStudents && permissions.canViewSessions;

  const { data: sessions = [], isLoading, refetch } = useQuery(
    getStudentSessions,
    { studentId: studentId ?? "" },
    { enabled },
  );
  const { data: trades = [] } = useQuery(
    getStudentAnalyticsTrades,
    { studentId: studentId ?? "", excludeInactive: false },
    { enabled: enabled && permissions.canViewAnalytics },
  );

  if (!studentId) return null;

  if (loadingStudents) {
    return (
      <StudentLayout
        studentId={studentId}
        studentFirstName={null}
        studentLastName={null}
        permissions={permissions}
      >
        <p className="text-sm text-muted-foreground">Chargement...</p>
      </StudentLayout>
    );
  }

  if (!permissions.canViewSessions) {
    return (
      <StudentLayout
        studentId={studentId}
        studentFirstName={student?.student?.firstName ?? null}
        studentLastName={student?.student?.lastName ?? null}
        permissions={permissions}
      >
        <p className="text-muted-foreground text-sm">{t.mentor.noPermissionSection}</p>
      </StudentLayout>
    );
  }

  return (
    <StudentLayout
      studentId={studentId}
      studentFirstName={student?.student?.firstName ?? null}
      studentLastName={student?.student?.lastName ?? null}
      studentEmail={student?.student?.email ?? undefined}
      permissions={permissions}
    >
      <SessionsView
        externalSessions={sessions as any[]}
        externalTrades={trades as any[]}
        externalIsLoading={isLoading}
        readOnly={true}
        studentId={studentId}
        onRefetch={() => refetch()}
      />
    </StudentLayout>
  );
}
